import { css } from '@emotion/react';
import { PropsWithChildren, useState } from 'react';

import { SasIcon, SasIconButton } from './SasIcon';
import { theme } from './theme';

const styles = {
  wrapper: css`
    position: relative;
    display: flex;
    align-items: center;
    gap: ${theme.spacing.sm};
    background-color: ${theme.colors.background.infoBox};
    padding: ${theme.spacing.sm};
    border-radius: ${theme.borders.radius.sm};
  `,

  content: css`
    font-size: ${theme.fontSize.sm};
    flex: 1;
  `,
};

type InformationBannerProps = PropsWithChildren<{
  className?: string;
  showClose?: boolean;
}>;

export const InformationBanner = ({ children, className, showClose = true }: InformationBannerProps) => {
  const [closed, setClosed] = useState(false);

  if (closed) {
    return null;
  }

  return (
    <div
      css={styles.wrapper}
      className={className}
      onClick={event => {
        event.stopPropagation();
      }}
    >
      <SasIcon name={'cl--info'} />
      <span css={styles.content}>{children}</span>
      {showClose && (
        <SasIconButton
          name={'cl--close'}
          color={theme.colors.gray[4]}
          onClick={event => {
            event.stopPropagation();

            setClosed(true);
          }}
        />
      )}
    </div>
  );
};
